import { render } from "./twitter.vue?vue&type=template&id=48015976"
import script from "./twitter.vue?vue&type=script&lang=js"
export * from "./twitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/policies/policies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__